import { detectPartnerFromHost } from './detect';
import { setCssVars, setFavicon, setTitle } from './domSetters';
import type { PartnerPreset, PartnerKey } from './registry';

declare global {
  interface Window {
    __PARTNER__?: { key: PartnerKey; appliedAt: number };
  }
}

/**
 * Apply a partner preset to the DOM
 */

function applyPreset(preset: PartnerPreset) {
  setTitle(preset.title);
  setCssVars(preset.cssVars);
  setFavicon(preset.faviconHref);
  document.documentElement.setAttribute('data-partner', preset.key);
}

/**
 * Initialize partner (pre-login) is called in index.tsx before rendering <App />
 */
export function initPartner() {
  // SSR / non-DOM guard
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const preset = detectPartnerFromHost();
  applyPreset(preset);

  // Tiny global hint for app code (non-authoritative)
  window.__PARTNER__ = { key: preset.key, appliedAt: Date.now() };

  // Optional: remember last key to minimize flicker across reloads
  try {
    localStorage.setItem('__partnerKey', preset.key);
  } catch {
    // ignore storage errors (private mode, etc.)
  }
}

